import { render, staticRenderFns } from "./ds-tree.vue?vue&type=template&id=c0659cc6"
import script from "./ds-tree.vue?vue&type=script&lang=js"
export * from "./ds-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports